import React from 'react';
import { OrbitComponent } from '../../../base-components/orbit-component/orbit-component';
import { SearchBoxTitleComponent } from '../search-box-title/search-box-title.component';
import { ISearchSuggestion } from '../../../../services/game-search/game-search-result';
import { observer } from 'mobx-react';
import { CyClass } from '../../../../../common/cy-classes';
import { SearchGameItemComponent } from '../search-game-item/search-game-item.component';
import { SearchGamesListBox } from '../found-games/boxes/search-games-list/search-games-list.box';

export interface SuggestedGamesComponentProps {
    items: ISearchSuggestion[];
}

@observer
export class SuggestedGamesComponent extends OrbitComponent<SuggestedGamesComponentProps> {

    private _renderGame(suggestedCategory: ISearchSuggestion) {
        return (
            <SearchGameItemComponent key={suggestedCategory.text} searchSuggestion={suggestedCategory} />
        )
    }

    private _renderGames() {
        return (
            <SearchGamesListBox className={CyClass('cy-found-games-list-box')}>
                { this.props.items.map(suggestedCategory => this._renderGame(suggestedCategory)) }
            </SearchGamesListBox>
        );
    }

    render() {
        if (this.props.items.length === 0) {
            return null;
        }

        return (
            <span className={CyClass('cy-suggested-links-suggested-games')}>
                <SearchBoxTitleComponent title={'SUGGESTED_GAMES'} />
                {this._renderGames()}
            </span>
        )
    }
}
